module.exports = __webpack_public_path__ + "media/img/aschuesseler-5f7b4a4d340d8bf26f64ca1220388742.jpg";